import React from 'react'
import { MenuItem } from '@material-ui/core'
import StorageIcon from '@material-ui/icons/Storage'
import { useHistory } from 'react-router-dom'

import { useUser } from '../hooks'
import { Routes } from './config/routes'

interface DemoDataMenuItemProps {
    onClose?: () => void
    className?: string
}

export const DemoDataMenuItem = ({
    onClose,
    className,
}: DemoDataMenuItemProps) => {
    const history = useHistory()
    const { rootUser } = useUser()
    const show = (rootUser?.email || '').toLowerCase().endsWith('@ezos.co')
    if (!show) return null

    return (
        <MenuItem
            className={className}
            onClick={() => {
                onClose?.()
                history.push(Routes.shared.demoData)
            }}
            style={{ display: 'flex', alignItems: 'center' }}
        >
            <StorageIcon style={{ marginRight: '8px' }} />
            Demo Data
        </MenuItem>
    )
}
